import { useQuery } from "@tanstack/react-query";
import { PriceRule } from "api/client.generated";
import { PriceRuleModel } from "types/price-rule-model";
import useApi from "../useApi";

interface UseSourcePartnerPriceRulesReturn {
  priceRules: PriceRuleModel[] | undefined;
  isPriceRulesFetching: boolean;
}

const useSourcePartnerPriceRules = (): UseSourcePartnerPriceRulesReturn => {
  const { partnersMigrationClient } = useApi();

  const loadData = async (): Promise<PriceRuleModel[]> => {
    const take = 100;
    let result: PriceRule[] = [];
    for (let skip = 0; ; skip += take) {
      const response = await partnersMigrationClient.getSourcePartnerPriceRules(skip, take);

      if (response.items) result = [...result, ...response.items];

      if (response.paging.count <= skip + take) break;
    }

    return result.map((rule) => new PriceRuleModel(rule)) ?? [];
  };

  const { data: priceRules, isFetching: isPriceRulesFetching } = useQuery({
    queryKey: ["getSourcePartnerPriceRules"],
    queryFn: loadData,
  });

  return { priceRules, isPriceRulesFetching };
};

export default useSourcePartnerPriceRules;
